import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Filter, IRecEffFilter, EmptyRecEffFilter } from "./Filter";
import { SubTable } from "./SubTable";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { Accordion, AccordionTab } from "primereact/accordion";
import { format } from "date-fns";
import { SubTableEfficiencyReport } from "../SubTableEfficiencyReport";
import { safeFormatDate } from "../../../models/DateFormatMapper";

interface IRecruiterEfficiency {
    login_ID?: number,
    recruiter?: string,
    branchName?: string,
    noOfSub?: number,
    noOfSubPV?: number,
    noOfSubClient?: number,
    noOfSubRejSales?: number,
    noOfSubRejPV?: number,
    noOfSubRejClient?: number,
    noOfECI?: number,
    noStatusNotChange?: number,
    noOfServe?: number,
    noOfUnServe?: number,
    noOfAllReq?: number,
    noOfReqHoldbyPV?: number,
    noOfNoRoomECS?: number,
    po?: number,
}

export const RecruiterEfficiency = (permissions: IPermissionProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IRecruiterEfficiency>, loading: boolean });
    const [tFooter, setTFooter] = useState<IRecruiterEfficiency>({});
    const [salEffFilter, setSalEffFilter] = useState<IRecEffFilter>(EmptyRecEffFilter);
    const [tableLoad, setTableLoad] = useState(false);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
    const DateFormat = loginObj?.date_Format;

    const dt = useRef<any>(null);
    const toast = useRef<any>(null);

    const [subTable, setSubTable] = useState({ open: false, salesID: 0, resType: 0, totalRec: null } as { open: boolean, salesID?: number, resType: number, totalRec?: boolean | null });
    const [subTable1, setSubTable1] = useState({ open: false, salesID: 0, resType: 0, totalRec: null } as { open: boolean, salesID?: number, resType: number, totalRec?: boolean | null });

    const hideSubTableDialog = () => {
        setSubTable({ open: false, salesID: 0, resType: 0, totalRec: null });
        setSubTable1({ open: false, salesID: 0, resType: 0, totalRec: null });
    };

    useEffect(() => {
        if (tableLoad) {
            loadTableData();
            setTableLoad(false);
        }
    }, [tableLoad]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const filter = { ...salEffFilter };
        filter.fromDate = filter.fromDate ? format(new Date(filter.fromDate), 'yyyy-MM-dd') : null;
        filter.toDate = filter.toDate ? format(new Date(filter.toDate), 'yyyy-MM-dd') : null;
        const response = await Fetch("Report_Recruiter_Efficiency", "GET", null, `filter=${encodeURIComponent(JSON.stringify(filter))}`, toast);
        if (response) {
            const data: Array<IRecruiterEfficiency> = await response.json();

            const _data: Array<IRecruiterEfficiency> = [];
            let totalNoOfSub = 0;
            let totalNoOfSubPV = 0;
            let totalNoOfSubClient = 0;
            let totalNoOfSubRejSales = 0;
            let totalNoOfSubRejPV = 0;
            let totalNoOfSubRejClient = 0;
            let totalNoOfECI = 0;
            let totalNoStatusNotChange = 0;
            let totalNoOfServe = 0;
            let totalNoOfUnServe = 0;
            let totalNoOfAllReq = 0;
            data.forEach((d, i) => {
                if (d.noOfSub) totalNoOfSub += d.noOfSub;
                if (d.noOfSubPV) totalNoOfSubPV += d.noOfSubPV;
                if (d.noOfSubClient) totalNoOfSubClient += d.noOfSubClient;
                if (d.noOfSubRejSales) totalNoOfSubRejSales += d.noOfSubRejSales;
                if (d.noOfSubRejPV) totalNoOfSubRejPV += d.noOfSubRejPV;
                if (d.noOfSubRejClient) totalNoOfSubRejClient += d.noOfSubRejClient;
                if (d.noOfECI) totalNoOfECI += d.noOfECI;
                if (d.noStatusNotChange) totalNoStatusNotChange += d.noStatusNotChange;
                if (d.noOfServe) totalNoOfServe += d.noOfServe;
                if (d.noOfUnServe) totalNoOfUnServe += d.noOfUnServe;
                if (d.noOfAllReq) totalNoOfAllReq += d.noOfAllReq;
                _data.push(d);
            });
            const totalRecords: IRecruiterEfficiency = {
                recruiter: "Total Records",
                noOfSub: totalNoOfSub,
                noOfSubPV: totalNoOfSubPV,
                noOfSubClient: totalNoOfSubClient,
                noOfSubRejSales: totalNoOfSubRejSales,
                noOfSubRejPV: totalNoOfSubRejPV,
                noOfSubRejClient: totalNoOfSubRejClient,
                noOfECI: totalNoOfECI,
                noStatusNotChange: totalNoStatusNotChange,
                noOfServe: totalNoOfServe,
                noOfUnServe: totalNoOfUnServe,
                noOfAllReq: totalNoOfAllReq
            };
            setTFooter(totalRecords);

            setTableData({ tableData: _data, loading: false });
        }
    }

    const rightToolbarTemplate = () => {
        const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
        return (
            permissions.is_Export || loginObj.is_Team_Lead ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Recruiter Efficiency Report</h5>
        </div>
    );

    const noOfSub = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 1 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfSub}</span>
    const noOfSubPV = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 2 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfSubPV}</span>
    const noOfSubClient = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 3 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfSubClient}</span>
    const noOfSubRejSales = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 4 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfSubRejSales}</span>
    const noOfSubRejPV = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 5 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfSubRejPV}</span>
    const noOfSubRejClient = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 6 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfSubRejClient}</span>
    const noOfECI = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 7 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfECI}</span>
    const noStatusNotChange = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 8 })} className="cursor-pointer text-cyan-700 underline">{rowData.noStatusNotChange}</span>
    const noOfAllReq = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 1 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfAllReq}</span>
    const noOfServe = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 5 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfServe}</span>
    const noOfUnServe = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 6 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfUnServe}</span>
    const noRoomForECS = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 14 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfNoRoomECS}</span>
    const reqHoldByPV = (rowData: IRecruiterEfficiency) => <span onClick={() => rowData.login_ID && setSubTable1({ open: true, salesID: rowData.login_ID, resType: 15 })} className="cursor-pointer text-cyan-700 underline">{rowData.noOfReqHoldbyPV}</span>


    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter setSalEffFilter={setSalEffFilter} onSearch={() => setTableLoad(true)} toast={toast} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                resizableColumns showGridlines columnResizeMode="expand" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small" stripedRows scrollable scrollHeight="70vh"
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} footer={tFooter.recruiter} />
                <Column field="recruiter" header="Recruiter" sortable body={(rowData) => <p style={{ color: rowData.user_Status ? "red" : "" }}>{rowData.recruiter.trim()}</p>} />
                <Column style={{ minWidth: "8rem" }} field="date_Of_Joining" header="DOJ" sortable body={(rowData) => <p>{safeFormatDate(rowData.date_Of_Joining, "dd/MM/yyyy", DateFormat)}</p>} />
                <Column field="working_Months" header="Tenure (M)" />
                <Column field="branchName" header="Recruiter Comp(Branch)" sortable />
                <Column field="teamManager" header="Team Manager" sortable />
                <Column field="resourceManagerName" header="Resource Manager" sortable />

                <Column field="noOfAllReq" header="#AllReq" sortable body={noOfAllReq} footer={() => {
                    const AllReq = tableData.tableData.reduce((sum, item) => sum + (item.noOfAllReq || 0), 0);
                    return <span
                        onClick={() => setSubTable({ open: true, resType: 1 })}
                        className="cursor-pointer text-cyan-700 underline">{AllReq}</span>;
                }} />
                <Column field="noOfServe" header="#Serve" sortable body={noOfServe} footer={() => {
                    const No_Serve = tableData.tableData.reduce((sum, item) => sum + (item.noOfServe || 0), 0);
                    return <span
                        onClick={() => setSubTable({ open: true, resType: 5 })}
                        className="cursor-pointer text-cyan-700 underline">{No_Serve}</span>;
                }} />
                <Column field="noOfUnServe" header="#UnServe" sortable body={noOfUnServe} footer={() => {
                    const UnServe = tableData.tableData.reduce((sum, item) => sum + (item.noOfUnServe || 0), 0);
                    return <span
                        onClick={() => setSubTable({ open: true, resType: 6, totalRec: true })}
                        className="cursor-pointer text-cyan-700 underline">{UnServe}</span>;
                }} />
                <Column field="noOfSub" header="#Sub" sortable body={noOfSub}
                    footer={() => {
                        const noOfSub = tableData.tableData.reduce((sum, item) => sum + (item.noOfSub || 0), 0);
                        return <span
                            onClick={() => setSubTable1({ open: true, resType: 1, totalRec: true })}
                            className="cursor-pointer text-cyan-700 underline">{noOfSub}</span>;
                    }}
                />
                <Column field="noOfSubPV" header="#SubPV" sortable body={noOfSubPV}
                    footer={() => {
                        const NOSubPv = tableData.tableData.reduce((sum, item) => sum + (item.noOfSubPV || 0), 0);
                        return <span
                            onClick={() => setSubTable1({ open: true, resType: 2, totalRec: true })}
                            className="cursor-pointer text-cyan-700 underline">{NOSubPv}</span>;
                    }} />
                <Column field="noOfSubClient" header="#SubClient" sortable body={noOfSubClient} footer={() => {
                    const NOSubPv = tableData.tableData.reduce((sum, item) => sum + (item.noOfSubClient || 0), 0);
                    return <span
                        onClick={() => setSubTable1({ open: true, resType: 3, totalRec: true })}
                        className="cursor-pointer text-cyan-700 underline">{NOSubPv}</span>;
                }} />
                <Column field="noOfSubRejSales" header="#SubRejSales" sortable body={noOfSubRejSales}
                    footer={() => {
                        const NOSubRejSales = tableData.tableData.reduce((sum, item) => sum + (item.noOfSubRejSales || 0), 0);
                        return <span
                            onClick={() => setSubTable1({ open: true, resType: 4, totalRec: true })}
                            className="cursor-pointer text-cyan-700 underline">{NOSubRejSales}</span>;
                    }}
                />
                <Column field="noOfSubRejPV" header="#SubRejPV" sortable body={noOfSubRejPV}
                    footer={() => {
                        const SubRejPV = tableData.tableData.reduce((sum, item) => sum + (item.noOfSubRejPV || 0), 0);
                        return <span
                            onClick={() => setSubTable1({ open: true, resType: 5, totalRec: true })}
                            className="cursor-pointer text-cyan-700 underline">{SubRejPV}</span>;
                    }} />

                <Column field="noOfSubRejClient" header="#SubRejClient" sortable body={noOfSubRejClient}
                    footer={() => {
                        const SubRejClient = tableData.tableData.reduce((sum, item) => sum + (item.noOfSubRejClient || 0), 0);
                        return <span
                            onClick={() => setSubTable1({ open: true, resType: 6, totalRec: true })}
                            className="cursor-pointer text-cyan-700 underline">{SubRejClient}</span>;
                    }} />
                <Column field="noOfECI" header="#ECI" sortable body={noOfECI}
                    footer={() => {
                        const ECI = tableData.tableData.reduce((sum, item) => sum + (item.noOfECI || 0), 0);
                        return <span
                            onClick={() => setSubTable1({ open: true, resType: 7, totalRec: true })}
                            className="cursor-pointer text-cyan-700 underline">{ECI}</span>;
                    }} />
                <Column field="noStatusNotChange" header="#StatusNotChange" sortable body={noStatusNotChange}
                    footer={() => {
                        const noStatusNotChange = tableData.tableData.reduce((sum, item) => sum + (item.noStatusNotChange || 0), 0);
                        return <span
                            onClick={() => setSubTable1({ open: true, resType: 8, totalRec: true })}
                            className="cursor-pointer text-cyan-700 underline">{noStatusNotChange}</span>;
                    }}
                />
                <Column field="po" header="#PO" sortable footer={() => {
                    const noOFPO = tableData.tableData.reduce((sum, item) => sum + (item.po || 0), 0);
                    return <span
                        className="cursor-pointer">{noOFPO}</span>;
                }} />
                <Column field="noOfNoRoomECS" header="NoOfNoRoomECS" body={noRoomForECS} sortable
                    footer={() => {
                        const noOfNoRoomECS = tableData.tableData.reduce((sum, item) => sum + (item.noOfNoRoomECS || 0), 0);
                        return <span
                            className="text-black">{noOfNoRoomECS}</span>;
                    }} />
                <Column field="noOfReqHoldbyPV" header="NoOfReqHoldby PV" body={reqHoldByPV} sortable
                    footer={() => {
                        const noOfReqHoldbyPV = tableData.tableData.reduce((sum, item) => sum + (item.noOfReqHoldbyPV || 0), 0);
                        return <span
                            className="text-black">{noOfReqHoldbyPV}</span>;
                    }}
                />

            </DataTable>
            <SubTable open={subTable1.open} salesID={subTable1.salesID} resType={subTable1.resType} hideDialog={hideSubTableDialog} toast={toast} salEffFilter={salEffFilter} totalRec={subTable1.totalRec} />
            <SubTableEfficiencyReport open={subTable.open} salesID={subTable.salesID} resType={subTable.resType} hideDialog={hideSubTableDialog} toast={toast} salEffFilter={salEffFilter} totalRec={subTable.totalRec} />
            <Toast ref={toast} />
        </>
    );
}
